import { createNode, PlainDateTimeDataType } from '@glueapp/graph-types';
import { Temporal } from '@js-temporal/polyfill';
import { fromPlainDateTime } from '../../utils/temporal';

export const NowDateTime = createNode({
    id: 'Now (DateTime)',
    name: 'Now (DateTime)',
    description: 'Returns the current date and time, optionally in a specific timezone',
    aiDescription:
        'Takes an optional timezone string on the "Timezone" port and outputs the current DateTime on the "DateTime" port. Defaults to the system timezone.',
    category: 'Date & Time',
    color: '#3b82f6',
    integration: undefined,
    inPorts: {
        Timezone: { kind: 'string' },
    },
    optionalInPorts: ['Timezone'],
    outPorts: {
        DateTime: PlainDateTimeDataType,
    },
    execute: function (input) {
        const timezone = input.inPorts.Timezone ?? Temporal.Now.timeZoneId();
        const dateTime = Temporal.Now.plainDateTimeISO(timezone);
        return { output: { DateTime: fromPlainDateTime(dateTime) } };
    },
});
